import { timeZoneApi } from '@/api/config-setup'
import { queryKeys } from '@/constant/common'
import { TIME_ZONE } from '@/types'
import { useQuery } from '@tanstack/react-query'

const useTimezoneOptions = () => {
  return useQuery(
    [queryKeys.timezoneOptions],
    async () => {
      return await timeZoneApi.getAll()
        .then(res => res.data)
        .catch(() => [] as TIME_ZONE[])
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    })
}

export default useTimezoneOptions
